/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

function validateCart(event) {
  event.preventDefault();
  let validCart = false;

  let cart = fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      if (isValidCart(cart.items)) {
        event.target.removeEventListener('click', validateCart);
        event.target.click();
        return true;
      }
    });

  return false;
}

// simplified version of validate cart
// prevent users from bypassing isValidCart through alternative checkout methods
async function validateAddFreeSamples(samples) {
  let validCart = false;

  await fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      if (isValidCart(cart.items.concat(samples))) {
        validCart = true;
      }
    });

  return validCart;
}

let checkoutButton = document.getElementById('checkout-submit');

// only bind the event listener if we're in the cart prior to checkout
if (checkoutButton) {
  checkoutButton.addEventListener('click', validateCart);
}

function isValidCart(items) {
  // TODO: are these Navidium products orphaned during a product delete??
  items = items.filter((item) => {
    return item.title ? !item.title.includes('Navidium') : true;
  });

  // return true if cart has either just one item, or no samples,
  // or the number of items is equal to the number of sample items (no mixed cart)
  // as long as the quantity of samples is less than 10
  if (items.length === 1) {
    return true;
  }

  let test = items.reduce(function (accumulator, item) {
    // TODO figure out why this can't be a nice one-liner
    // accumulator + /FDB Sample/.test(item.vendor) ? 1 : 0;
    let sampleItem = /FDB Sample/.test(item.vendor) ? 1 : 0;
    return accumulator + sampleItem;
  }, 0);

  try {
    console.info('Checking for mixed carts:');
    if (!(test === 0 || test === items.length))
      throw 'Free samples cannot be shipped with blinds / shades - please place them on a separate order.';

    // limit customers to 10 samples
    console.info('Checking for orders which exceed the free-sample limit:');
    let sampleCount = items.reduce(function (accumulator, item) {
      let qty = /FDB Sample/.test(item.vendor) ? item.quantity : 0;
      return accumulator + qty;
    }, 0);

    if (sampleCount > 10) {
      let overLimit = sampleCount - 10;

      throw overLimit === 1
        ? 'You may order a maximum of 10 free samples.  Please remove 1 sample to proceed.'
        : 'You may order a maximum of 10 free samples.  Please remove ' +
            overLimit +
            ' samples to proceed.';
    }

    return true;
  } catch (error) {
    let flashNotice = new Flash(error, { isError: true });
    flashNotice.show();
    return false;
  }
}

// flash / notifications
let flashNotice;
let flashError;
let wrapperNode;
let templateNode;
let hiddenFlashOffset;
const CLASSES = {
  CONTAINER: 'flash-container',
  FLASH: 'flash-message',
  FLASH_CONTENT: 'flash-message__content',
  CLOSE_BUTTON: 'flash-message__close-button',
  ERROR: 'flash-message--error',
  ANIMATE_IN: 'flash-message--is-animating-in',
  ANIMATE_OUT: 'flash-message--is-animating-out',
  ANIMATE_DOWN: 'flash-message--is-animating-down',
};
const ATTRIBUTES = {
  STYLE: 'style',
  CSS_VARIABLE: '--element-height',
  ROLE: 'role',
  ROLE_ALERT: 'alert',
  ROLE_STATUS: 'status',
};
const EVENTS = {
  CLICK: 'click',
  ANIMATION_END: 'animationend',
  FLASH_HIDING: 'flash:hiding',
  DOM_READY: 'DOMContentLoaded',
};
const flash_messages = [];
const flash_helpers = {
  removeMessage: function (hiddenMessage) {
    flash_messages.slice(hiddenMessage.index + 1).forEach((flash) => {
      flash_helpers.shiftMessageDown(flash.node, hiddenMessage.height);
    });
    if (hiddenMessage.index !== -1) {
      flash_messages.splice(hiddenMessage.index, 1);
    }
  },

  shiftMessageDown: function (node, height) {
    node.classList.add(CLASSES.ANIMATE_DOWN);
    node.style.setProperty(ATTRIBUTES.CSS_VARIABLE, height);
    node.addEventListener(EVENTS.ANIMATION_END, () => {
      node.removeAttribute(ATTRIBUTES.STYLE);
      node.classList.remove(CLASSES.ANIMATE_DOWN);
    });
  },

  setHiddenFlashOffset: function (node) {
    const height = node.offsetHeight;
    if (node.nextSibling) {
      const siblingMargin = parseFloat(
        window.getComputedStyle(node.nextSibling).marginBottom,
      );
      hiddenFlashOffset = `${height + siblingMargin}px`;
    }
  },
};

class Flash {
  constructor(message, options = { isError: false, noticeDuration: 40000 }) {
    this.message = message;
    this.node = templateNode.cloneNode(true);
    this.isError = options.isError;
    this.contentNode = this.node.querySelector(`.${CLASSES.FLASH_CONTENT}`);
    this.closeButton = this.node.querySelector(`.${CLASSES.CLOSE_BUTTON}`);
    this.wrapperNode = wrapperNode;
    this.lastFocusedElement = document.activeElement || document.body;
    this.timeout = null;
    if (this.isError) {
      this.duration = null;
    } else {
      this.duration = options.noticeDuration;
    }
  }

  show() {
    flash_messages.push(this);
    this.closeButton.addEventListener(EVENTS.CLICK, () => {
      this.hide();
    });
    if (this.isError) {
      this.node.classList.add(CLASSES.ERROR);
      this.contentNode.setAttribute(ATTRIBUTES.ROLE, ATTRIBUTES.ROLE_ALERT);
    } else {
      this.contentNode.setAttribute(ATTRIBUTES.ROLE, ATTRIBUTES.ROLE_STATUS);
      this.timeout = setTimeout(() => this.hide(), this.duration);
    }
    this.contentNode.textContent = this.message;
    this.wrapperNode.appendChild(this.node);
    this.contentNode.focus();
    this.node.classList.add(CLASSES.ANIMATE_IN);
    this.node.addEventListener(EVENTS.ANIMATION_END, () => {
      this.node.classList.remove(CLASSES.ANIMATE_IN);
    });
  }

  hide() {
    flash_helpers.setHiddenFlashOffset(this.node);
    document.dispatchEvent(
      new CustomEvent(EVENTS.FLASH_HIDING, {
        detail: {
          index: flash_messages.indexOf(this),
          height: hiddenFlashOffset,
        },
      }),
    );
    this.node.classList.add(CLASSES.ANIMATE_OUT);
    this.node.addEventListener(EVENTS.ANIMATION_END, () => {
      this.node.classList.remove(CLASSES.ANIMATE_OUT);
      this.wrapperNode.removeChild(this.node);
      if (this.wrapperNode.children.length) {
        this.wrapperNode.lastChild
          .querySelector(`.${CLASSES.FLASH_CONTENT}`)
          .focus();
      } else {
        this.lastFocusedElement.focus();
      }
    });
  }
}

document.addEventListener(EVENTS.DOM_READY, () => {
  wrapperNode = document.querySelector(`.${CLASSES.CONTAINER}`);
  templateNode = document.querySelector(`.${CLASSES.FLASH}`);

  document.addEventListener(EVENTS.FLASH_HIDING, (event) => {
    const hiddenMessage = {
      index: event.detail.index,
      height: event.detail.height,
    };
    flash_helpers.removeMessage(hiddenMessage);
  });
});

//-------------------------------------------- Coded by Rayman -------------------------------------------\\

(function ($) {
  var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
    navigator.userAgent,
  );

  function dropdownInit() {
    $('.dd:not(.dd--hover)').each(function () {
      var $this = $(this);
      var $toggle = $this.find('.dd__toggle');
      var $list = $this.find('.dd__list li');
      var $content = $this.find('.dd__content');

      $toggle.on('click', function (e) {
        if ($this.hasClass('active')) {
          $this.removeClass('active');
        } else {
          $('.dd').removeClass('active');
          $this.addClass('active');
        }
      });

      if ($this.hasClass('dd-select')) {
        $list.on('click', function () {
          var value = $(this).data('value');
          $toggle.contents().first().remove();
          if (value) {
            $toggle.text(value);
          }
          $this.removeClass('active');
        });
      }

      if ($this.hasClass('dd-accordion')) {
        $toggle.on('click', function (e) {
          e.preventDefault(400);
          $content.slideToggle();
        });
        $list.on('click', function () {
          $content.slideUp(400);
        });
      }

      $(document).on('click', function (e) {
        var container = $('.dd');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.dd').removeClass('active');
        }
      });
    });
  }

  function sliderInit() {
    // Featured Product Slider

    $('.featured-product-slider')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 800,
        draggable: false,
        useTransform: true,
        centerMode: false,
        infinite: false,
        rows: 0,
        centerPadding: '0',
        swipe: false,
        cssEase: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

    // Featured Slideshow

    var $slideshow = $('.featured-slideshow');

    $slideshow.on('init', function (event, slick) {
      var $anim = slick.$slides.eq(0).find('.anim');
      $anim.addClass('animated');
    });

    $slideshow.on('afterChange', function (event, slick, currentSlide) {
      $('.anim').removeClass('animated');
      var $anim = slick.$slides.eq(currentSlide).find('.anim');
      $anim.each(function (i) {
        var $this = $(this);
        setTimeout(function () {
          $this.addClass('animated');
        }, 100 * i);
      });
    });

    $slideshow.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 800,
      draggable: false,
      useTransform: true,
      rows: 0,
      centerPadding: '0',
      swipe: false,
      cssEase: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            swipe: true,
            arrows: false,
          },
        },
      ],
    });

    // Collection Slider

    $('.slider-column-4')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 800,
        useTransform: true,
        infinite: false,
        centerPadding: '0',
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 3,
              arrows: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
              arrows: false,
            },
          },
        ],
      });

    // Testimonial Slider

    $('.slider-column-2')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 800,
        draggable: false,
        useTransform: true,
        infinite: false,
        rows: 0,
        centerPadding: '0',
        swipe: false,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              arrows: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
              arrows: false,
            },
          },
        ],
      });

    // Featured Blog Slider

    $('.slider-column-3')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 800,
        draggable: false,
        useTransform: true,
        infinite: false,
        rows: 0,
        centerPadding: '0',
        swipe: false,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              arrows: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
              arrows: false,
            },
          },
        ],
      });

    // Product Slider

    $('.product-single__slider')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        draggable: false,
        centerMode: false,
        infinite: false,
        rows: 0,
        centerPadding: '0',
        swipe: false,
        asNavFor: '.product-single__thumbnails',
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              arrows: false,
            },
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              dots: true,
              draggable: true,
              swipe: true,
            },
          },
        ],
      });
    $('.product-single__thumbnails').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.product-single__slider',
      variableWidth: true,
      draggable: false,
      centerMode: false,
      infinite: false,
      rows: 0,
      centerPadding: '0',
      swipe: false,
      arrows: false,
      dots: false,
      focusOnSelect: true,
    });
  }

  function accordionInit() {
    $('.acc').each(function () {
      var $this = $(this);
      var $accPanel = $this.find('.acc__panel');
      var $accToggle = $this.find('.acc__toggle');
      var $accContent = $this.find('.acc__content');
      $accToggle.on('click', function (e) {
        e.preventDefault();
        var $accNextContent = $(this).next();
        $accPanel.removeClass('active');
        $accToggle.removeClass('active');
        $accContent.slideUp();
        if ($accNextContent.is(':hidden')) {
          $accNextContent.slideDown();
          $(this).addClass('active');
          if ($accToggle.length > 0) {
            $(this).parent('.acc__panel').addClass('active');
          }
        } else {
          $accNextContent.slideUp();
          $accPanel.removeClass('active');
          $(this).removeClass('active');
          if ($accToggle.length > 0) {
            $(this).parent('.acc__panel').removeClass('active');
          }
        }
      });
    });
  }

  function customSelect() {
    $('.custom-select').each(function (index) {
      var $this = $(this),
        $option = $this.children('option'),
        $optionLength = $option.length;

      $this.hide();
      $this.wrap('<div class="dd dd-select" data-index="' + index + '"></div>');
      $this.after('<div class="dd__toggle"></div>');

      var location = window.location.search;
      var params = location.split('=')[1];
      var href = window.location.href.split('/');
      var filtered;
      for (var i = 0; i < href.length; i++) {
        filtered = href[i].split('?')[0];
      }

      var $selectText = $this.next('.dd__toggle');
      $selectText.text($option.eq(0).text());

      var $ddContent = $('<div />', {
        class: 'dd__content',
      }).insertAfter($selectText);

      var $ul = $('<ul />', {
        class: 'dd__list',
      }).appendTo($ddContent);

      for (var i = 0; i < $optionLength; i++) {
        $('<li />', {
          text: $option.eq(i).text(),
          rel: $option.eq(i).val(),
        }).appendTo($ul);

        var currentValue = $option.eq(i).val();
        var currentText = $option.eq(i).text();
        if (params === currentValue) {
          $selectText.text(currentText);
          $ul.find('li[rel="' + currentValue + '"]').addClass('active');
        }
        if (filtered === currentText) {
          $selectText.text(filtered);
        }
      }

      var $listItems = $ul.children('li');
      var $ddWrapper = $ddContent.closest('.dd-select');

      $selectText.on('click', function (event) {
        event.preventDefault();
        $('.dd-select').removeClass('active');
        $(this).parent().toggleClass('active');
      });

      $listItems.on('click', function (event) {
        event.preventDefault();
        var text = $(this).text();
        var value = $(this).attr('rel');
        var index = $ddWrapper.data('index');
        $selectText.text(text);
        $(this).addClass('active');
        $('.dd-select').removeClass('active');

        if ($this.hasClass('filter-select')) {
          $this.val(value).trigger('change');
        }

        if ($this.hasClass('product-select')) {
          $('.selector-wrapper')
            .eq(index)
            .find('.single-option-selector')
            .val(value)
            .trigger('change');
        }
      });

      $(document).on('click', function (event) {
        if (!$(event.target).closest('.dd-select').length) {
          $('.dd-select').removeClass('active');
        }
      });
    });
  }

  function menuInit() {
    $('.filter-toggle').on('click', function () {
      $('body').addClass('filter-open');
    });
    $('.filter-close').on('click', function () {
      $('body').removeClass('filter-open');
    });

    $('.sort-toggle').on('click', function () {
      $('.filter__sort').slideToggle();
    });
  }

  function alertInit() {
    $('.alert').each(function () {
      var $this = $(this);
      var $alertClose = $this.find('.alert__close');
      $alertClose.on('click', function (e) {
        e.preventDefault();
        $this.fadeOut(400, function () {
          $this.remove();
        });
      });
    });
  }

  function selectInit() {
    $('.select-link').on('change', function (e) {
      e.preventDefault();
      var value = $(this).val();
      window.location.href = value;
    });
  }

  function hideImageBlock() {
    $('.image-block').each(function () {
      var block = $(this).find('.image-block__inner');
      if (block.length === 0) {
        $(this).hide();
      }
    });
  }

  function stickyHeader() {
    var distance = 200;
    var $headerWrapper = $('.drawer__header-container');
    var $header = $('.site-header');
    var headerOffset = $header.offset().top + $header.outerHeight();
    var headerOffsetShow = headerOffset + distance;

    var spacer = $('<div class="header-spacer" />');
    spacer.css({
      height: $header.outerHeight(),
    });

    $(window).on('scroll', function () {
      var windowScroll = $(window).scrollTop();

      if (windowScroll > headerOffset) {
        $header.addClass('header-hide');
        $headerWrapper.addClass('header-fixed-hide');
      }

      if (windowScroll > headerOffsetShow) {
        $headerWrapper.addClass('header-fixed');
        if (spacer) {
          spacer.insertAfter('.drawer__header-container');
        }
        $header.removeClass('header-hide').addClass('header-show');
        $headerWrapper.removeClass('header-fixed-hide');
      } else {
        $header.removeClass('header-show');
      }

      if (windowScroll < headerOffset) {
        $header.removeClass('header-hide');
        $headerWrapper.removeClass('header-fixed-hide');
        $headerWrapper.removeClass('header-fixed');
        $('.header-spacer').detach();
      }
    });

    $(window).trigger('scroll');
  }

  // function builderInit() {
  //     var $input = $('.builder__control').find('input');
  //     $input.on('focus', function() {
  //         var $stepContent = $(this).closest('.step-content');
  //         var $nextStep = $stepContent.next();
  //         var offset = $nextStep.offset().top - ($('.site-header').outerHeight() - 50);
  //         $('body, html').animate({
  //             scrollTop: offset
  //         }, 600);
  //     });
  // }

  function productFAQ() {
    $('.sliding-link').click(function (e) {
      e.preventDefault();
      var aid = $(this).attr('href');
      $('html,body').animate({ scrollTop: $(aid).offset().top - 100 }, 'slow');
    });

    $(function () {
      $('.faq-accordion').accordion({
        collapsible: true,
        active: false,
        heightStyle: 'content',
      });
    });
  }

  function freeSamples() {
    console.info('Generating free samples...');
    // var samples_obj;
    let product_list = $('.product-list');
    let swatches_list = $('.swatches-list');
    let sample_count = $('.sample-count');
    $(document).on('click', '.product-groups .builder__control', function () {
      let group_handle = $(this).find('input').val();
      sample_count.text('0');
      product_list.empty().append('<div class="loading-animation"></div>');
      $('#step-2').show();
      $.each(samples_obj[group_handle], function (i, v) {
        let pl_item =
          `
          <div class="grid__item small--two-quarters medium-up--two-quarters large-up--one-quarter">
              <div class="builder__item builder__panel">
                  <label class="control builder__control">
                      <input type="radio" name="product" value="` +
          v.handle +
          `">
                      <span class="builder__control-indicator"></span>
                      <span class="builder__control-item"><img class="thumb lazyload" data-src="` +
          v.image +
          `" alt="` +
          v.name +
          `"></span>
                      <span class="builder__control-label text-large">` +
          v.name +
          `</span>
                  </label>
              </div>
          </div>`;
        product_list.append(pl_item);
      });

      $('html, body').animate(
        {
          scrollTop:
            $('#step-2').offset().top - $('header.site-header').outerHeight(),
        },
        600,
        function () {
          setTimeout(function () {
            product_list.find('.loading-animation').remove();
          }, 1000);
        },
      );
    });

    $(document).on('click', '.product-list .builder__control', function () {
      let list_handle = $(this).find('input').val();
      $('#step-3').show();
      swatches_list.html('<li><div class="loading-animation"></div></li>');
      $('.builder__cart').show();

      let url = '/collections/' + list_handle + '?view=free-samples-json';

      $.ajax({
        url: url,
        success: function (result) {
          let markup = '';
          let json_result = $.parseJSON(result);
          if (json_result.result_count > 0) {
            $.each(json_result.results, function (i, v) {
              let sl_item =
                `
                <li>
                    <div class="builder__item">
                        <label class="control builder__control">
                            <input type="checkbox" value="` +
                v.id +
                `">
                            <span class="builder__control-indicator"></span>
                            <span class="builder__control-item"><img class="thumb lazyload" data-src="` +
                v.image +
                `" alt="` +
                v.handle +
                `" style="width:100%;"></span>
                            <span class="builder__control-label text-small">` +
                v.name +
                `</span>
                        </label>
                    </div>
                </li>`;
              markup += sl_item;
            });
          } else {
            swatches_list.html('<p>No swatches found.</p>');
          }

          swatches_list.html(markup);
        },
      });

      $('html, body').animate(
        {
          scrollTop:
            $('#step-3').offset().top - $('header.site-header').outerHeight(),
        },
        600,
        function () {
          setTimeout(function () {
            swatches_list.find('.loading-animation').remove();
          }, 1000);
        },
      );
    });

    $(document).on('click', '.swatches-list .builder__control', function () {
      let input = $(this).find('input');
      input.prop('checked', !input.prop('checked'));
      sample_count.text(swatches_list.find('input:checked').length);
      return false;
    });

    $('.add-free-samples').on('click', async function (event) {
      if (swatches_list.find('input:checked').length > 0) {
        let items = [];

        swatches_list.find('input:checked').each(function () {
          let obj = {};
          obj['quantity'] = 1;
          obj['id'] = $(this).val();
          obj['vendor'] = 'FDB Sample';
          items.push(obj);
        });

        let data = { items: items };

        if (await validateAddFreeSamples(items)) {
          $.post(
            '/cart/add.js',
            data,
            function (data) {
              window.location = '/cart';
            },
            'json',
          );
        }
      } else {
        $('html, body').animate(
          {
            scrollTop:
              $('#step-1').offset().top - $('header.site-header').outerHeight(),
          },
          600,
        );
      }
    });
  }

  setTimeout(function () {
    sliderInit();
    accordionInit();
    dropdownInit();
    menuInit();
    alertInit();
    selectInit();
    hideImageBlock();
    stickyHeader();
    freeSamples();
    productFAQ();
    // builderInit();

    if (!isMobile) {
      customSelect();
    }
  }, 1000);
})(jQuery);
